/**
 * Módulos que se pueden apagar sin borrar su código.
 *
 * VPS_FILE_CLEANUP_ENABLED — Borrado de archivos desde el panel VPS.
 *   Desactivado el 2026-10-01 y reactivado el 2026-10-04 (doc 0431, A-05): ya no
 *   pasa por shell y no puede borrar fuera de public/.
 *   Su par en el backend es VPS_FILE_CLEANUP_ENABLED del .env (encendido salvo "false").
 */
export const VPS_FILE_CLEANUP_ENABLED = true;

export const VPS_FILE_CLEANUP_OFF_MSG =
  "Borrado de archivos desactivado temporalmente por seguridad (doc 0431)";
